import GlobalTable from '@/components/probaworkflows_base_components/GlobalTable/GlobalTable.vue';
import alert_mixin from "@/utils/mixins/alert_mixin";
import formatting_mixins from "@/utils/mixins/formatting_mixins";
import NavigationBackButton from "@/components/probaworkflows_base_components/NavigationBackButton/NavigationBackButton.vue";
import { nextTick } from "vue";
import {
  GET_QUESTIONS_IN_PROJECT,
  ADD_QUESTION_TO_RISK_FRAMEWORK,
  GET_QUESTIONS_ASSIGNED,
  GET_OPTION_WEIGHTS,
  SAVE_OPTION_WEIGHTS,
  GET_RISK_CATEGORIES,
  SAVE_RISK_CATEGORIES,
  get_project_id,
  get_headers,
} from "@/utils/constants/constants.js";
import axios from "axios";
import $ from "jquery";

export default {
  name: "RiskQuestions",
  mixins: [alert_mixin, formatting_mixins],
  components: {
    GlobalTable,
    NavigationBackButton,
  },
  data: () => ({
    active_tab: "Risk Categories",
    tabs: ["Risk Categories", "Question Assignments", "Checklist Weightings"],
    headers: "",
    question_list: [],
    table_safe_question_list: [],
    question_table_headers: [],
    risk_categories: [],
    manage_question_assign: [],
    manage_checklist: [],
    project_id: get_project_id(),
    selected_questions: [],
    risk_framework_assessment_id: null,
    assigned_questions: [],
    checklist_weight_questions: []

  }),
  computed: {
    filtered_data() {
      switch (this.active_tab) {
        case "Risk Categories":
          return this.risk_categories;
        case "Question Assignments":
          return this.manage_question_assign;
        case "Checklist Weightings":
          return this.manage_checklist;
        default:
          return [];
      }
    },
    can_save_checklist_weights() {
      return this.checklist_weight_questions.some(q =>
        q.choices.some(choice => choice.weight > 0)  // at least one non-zero weight
      );
    }
  },
  mounted() {
    this.headers = get_headers();
    this.risk_framework_assessment_id = sessionStorage.getItem("assessment_id");
    this.get_assigned_questions()
    .then(() => this.get_questions())
    .then(() => this.load_checklist_weights())
    .then(() => this.load_risk_categories());
  },
  methods: {
    async set_active_tab(tab) {
      this.active_tab = tab;
      sessionStorage.setItem("active_tab", tab);
      await nextTick();

      if (tab === "Question Assignments") {
        setTimeout(() => {
          const table = $("#question_management_table");

          if (!table.length) {
            return;
          }

          if ($.fn.DataTable.isDataTable(table)) {
            table.DataTable().clear().destroy();
          }

          table.DataTable({
            responsive: true,
            autoWidth: false,
            pageLength: 10,
            columnDefs: [{ orderable: false, targets: 4 }],
          });

        }, 100);
      }
    },



    get_questions() {
      this.question_list = [];
      const payload = { project_id: this.project_id };

      return axios
        .post(GET_QUESTIONS_IN_PROJECT, payload, { headers: this.headers })
        .then((response) => {
          const response_data =
            typeof response.data === "string"
              ? JSON.parse(response.data)
              : response.data;
          this.question_list = response_data.data;
          this.prep_tables();
        })
        .catch((error) => {
          if (error.response?.message !== 'error') {
            this.show_error(`Error getting questions: ${error}`);
          }
        });
    },

    prep_tables() {
      if (this.question_list.length > 0) {
        const sorted_questions = [...this.question_list].sort((a, b) => a.id - b.id);
        const allowed_types = ["single_select", "multi_select"];
        const filtered = sorted_questions.filter((q) =>
          allowed_types.includes(q.question_type)
        );

        this.table_safe_question_list = filtered.map((question) => ({
          id: question.id,
          question: question.question_text,
          type: this.format_question_type(question.question_type),
          choices: question.multi_select_choices.map((c) => c.choice).join(", "),
        }));

        this.checklist_weight_questions = filtered.map((question) => ({
          id: question.id,
          question: question.question_text,
          choices: question.multi_select_choices.map((choice) => ({
            option_id: choice.id,
            option: choice.choice,
            weight: 0,
          })),
        }));
      }
    },



    toggle_selection(id) {
      if (this.selected_questions.includes(id)) {
        this.selected_questions = this.selected_questions.filter((q) => q !== id);
      } else {
        this.selected_questions.push(id);
      }
    },
    async assign_selected_questions_to_assessment() {
    if (!this.risk_framework_assessment_id) {
      this.show_error("Assessment ID not set");
      return;
    }

    if (this.selected_questions.length === 0) {
      this.show_error("Please select at least one question to assign");
      return;
    }

    const payload = {
      risk_framework_assessment_id: this.risk_framework_assessment_id,
      question_ids: this.selected_questions,
    };

    try {
      const response = await axios.post(
        ADD_QUESTION_TO_RISK_FRAMEWORK,
        payload,
        { headers: this.headers }
      );

      if (response.data.status === "success") {
        this.show_success("Questions assigned to risk assessment successfully");
        this.selected_questions = [];
      } else {
        this.show_error(response.data.message || "Assignment failed");
      }
    } catch (error) {
      this.show_error(
        error.response?.data?.message || "Failed to assign questions"
      );
    }
  },
  get_assigned_questions() {
  return axios
    .get(GET_QUESTIONS_ASSIGNED, {
      headers: this.headers,
      params: {
        assessment_id: this.risk_framework_assessment_id,
      },
    })
    .then((response) => {
      if (response.data.status === "success") {
        this.assigned_questions = response.data.data;

        this.selected_questions = this.assigned_questions.map(
          (q) => q.question
        );
      } else {
        this.show_error(response.data.message || "Failed to fetch assigned questions");
      }
    })
    .catch((error) => {
      this.show_error(error.response?.data?.message || "Error loading assigned questions");
    });
   },
    save_checklist_weights() {
      const items = [];

      this.checklist_weight_questions.forEach(q => {
        q.choices.forEach(choice => {
          if (choice.weight > 0) {
            items.push({
              question_id: q.id,
              option_id: choice.option_id,
              weight: choice.weight
            });
          }
        });
      });

      if (items.length === 0) {
        this.show_error("Please enter at least one weight before saving.");
        return;
      }

      const payload = {
        assessment_id: this.risk_framework_assessment_id,
        items
      };

      axios.post(SAVE_OPTION_WEIGHTS, payload, { headers: this.headers })
        .then(response => {
          if (response.data.status === "success") {
            this.show_success("Checklist weights saved successfully!");
          } else {
            this.show_error("Failed to save checklist weights.");
          }
        })
        .catch(err => {
          this.show_error("Error saving checklist weights.", err.response?.data?.message || err.message);
        });
    },


    load_checklist_weights() {
    axios.get(GET_OPTION_WEIGHTS, {
        headers: this.headers,
        params: { assessment_id: this.risk_framework_assessment_id }
    })
        .then(response => {
        if (response.data.status === "success") {
            const weight_data = response.data.data;
            this.checklist_weight_questions.forEach(question => {
            const match = weight_data.find(q => q.question_id === question.id);
            if (match) {
                question.choices.forEach(choice => {
                const choice_match = match.choices.find(c => c.option === choice.option);
                if (choice_match) {
                    choice.weight = choice_match.weight;
                }
                });
            }
            });
        }
        })
        .catch(err => {
        this.show_error("Error loading checklist weights.", err.response?.data?.message || err.message);
        });
    },

    load_risk_categories() {
      axios.get(GET_RISK_CATEGORIES, {
        headers: this.headers,
        params: { assessment_id: this.risk_framework_assessment_id }
      })
        .then(response => {
          if (response.data.status === "success") {
            this.risk_categories = response.data.data;
          }
        })
        .catch(error => this.show_error("Error loading risk categories.", error));
    },

    save_risk_categories() {
      const valid = this.risk_categories.filter(cat => cat.risk_level && cat.min_value <= cat.max_value);

      if (valid.length === 0) {
        return this.show_error("Enter valid risk categories.");
      }

      const requests = valid.map(cat => {
        return axios.post(SAVE_RISK_CATEGORIES, {
          risk_framework_assessment_id: this.risk_framework_assessment_id,
          risk_level: cat.risk_level,
          min_value: cat.min_value,
          max_value: cat.max_value,
          auto_decision: cat.auto_decision,
          color_code: cat.color_code,
        }, { headers: this.headers });
      });

      Promise.all(requests)
        .then(responses => {
          const failed = responses.filter(r => r.data.status !== "success");
          if (failed.length === 0) {
            this.show_success("Risk categories saved successfully.");
            this.load_risk_categories();
          } else {
            this.show_error("Some categories failed to save.");
          }
        })
        .catch(err => this.show_error("Error saving categories.", err));
    },

    add_risk_category() {
      this.risk_categories.push({
        risk_level: "",
        min_value: 0,
        max_value: 0,
        color_code: "",
        auto_decision: "",
        automated_actions: [],
        is_new: true
      });
    },

    remove_risk_category(index) {
      this.risk_categories.splice(index, 1);
    }

  },
};
